import React, { useState } from 'react'
import { Popover, PopoverBody } from 'reactstrap'
import { BsThreeDots } from 'react-icons/bs'
import { BiFolder } from 'react-icons/bi'
// This component's `.lib-mobile-*` classes live in the list stylesheet. Its
// one caller (TriviaLibraryListPage) already imports it, so today the styles
// resolve either way — importing it here keeps the component self-contained
// if it is ever rendered from somewhere else. CRA dedupes the import.
import '../trivvy-list-bwai.css'
import { formatItemCount } from './folderService'

// A folder rendered as a card in the Library mobile list — matches the Library
// survey card (white, rounded 12px, 3-dots top-right). Tapping the content opens
// the folder; admins get an Open / Rename / Delete menu. Library-only (the Lines
// screens use FolderRowMobileLines instead).
const FolderRowMobile = ({
  folder,
  itemCount,
  itemNoun,
  isAdmin,
  onOpen,
  onRename,
  onDelete,
}) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const popoverId = `folderCardMobile_${folder._id}`

  return (
    <div className="lib-mobile-card">
      {isAdmin && (
        <div className="lib-mobile-card-menu">
          <span
            id={popoverId}
            className="cursor-pointer"
            onClick={() => setMenuOpen(true)}>
            <BsThreeDots />
          </span>
          <Popover
            isOpen={menuOpen}
            target={popoverId}
            toggle={() => setMenuOpen(false)}
            placement="bottom"
            modifiers={{
              flip: { boundariesElement: 'viewport' },
              preventOverflow: { boundariesElement: 'viewport' },
            }}
            hideArrow
            className="surveyListRow_Popover">
            <PopoverBody>
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  setMenuOpen(false)
                  if (onOpen) {
                    onOpen()
                  }
                }}>
                Open folder
              </div>
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  setMenuOpen(false)
                  if (onRename) {
                    onRename(folder)
                  }
                }}>
                Rename folder
              </div>
              <div
                className="dropdown-item my-1 cursor-pointer folder-menu-item-delete"
                onClick={() => {
                  setMenuOpen(false)
                  if (onDelete) {
                    onDelete(folder)
                  }
                }}>
                Delete folder
              </div>
            </PopoverBody>
          </Popover>
        </div>
      )}

      <div
        className="cursor-pointer folder-card-mobile-content"
        onClick={() => {
          if (onOpen) {
            onOpen()
          }
        }}>
        <div className="folder-row-icon-wrap">
          <BiFolder className="folder-row-icon" />
        </div>
        <div className="folder-card-mobile-text">
          <span className="lib-mobile-title">{folder.name}</span>
          <p className="lib-mobile-meta">
            {formatItemCount(itemCount, itemNoun)}
          </p>
        </div>
      </div>
    </div>
  )
}

export default FolderRowMobile
